import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  injectColumns (): void {
    const params = new URLSearchParams(window.location.search)
    const sc = params.getAll('sc[]')
    const scX = params.get('sc_x') ?? ''

    if (scX !== '') {
      this.appendHidden('sc_x', scX)
      return
    }

    if (sc.length === 0) return

    sc.forEach((value) => this.appendHidden('sc[]', value))
  }

  private appendHidden (name: string, value: string): void {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    this.element.appendChild(input)
  }
}
